import png from './images/eels.png'

export const colors = {
  dominant: '#FFDA00',
  highlight: '#fcb53e',
}
export const fullname = 'Eels'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/eels.js